import type { EventType, ReportSummary, SpeciesBucket } from '../types/contact'

const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1'

export interface SubmitReportRequest {
  species_bucket: SpeciesBucket
  event_type: EventType
  description?: string
  lat: number
  lon: number
  accuracy_m?: number
  observed_at: string
}

export async function submitReport(
  token: string,
  body: SubmitReportRequest,
): Promise<ReportSummary> {
  const res = await fetch(`${BASE}/reports`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { detail?: string }).detail ?? 'Failed to submit report')
  }
  return res.json()
}

export async function fetchMyReports(token: string): Promise<ReportSummary[]> {
  const res = await fetch(`${BASE}/reports/mine`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) throw new Error('Failed to load your reports')
  return res.json()
}

export async function flagReport(token: string, reportId: string, reason: string): Promise<{ id: string; flag_count: number }> {
  const res = await fetch(`${BASE}/reports/${reportId}/flag`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ reason }),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { detail?: string }).detail ?? 'Failed to flag report')
  }
  return res.json()
}

export async function uploadReportPhotos(
  token: string,
  reportId: string,
  files: File[],
): Promise<{ id: string; photo_count: number }> {
  const form = new FormData()
  files.forEach((f) => form.append('files', f))

  const res = await fetch(`${BASE}/reports/${reportId}/photos`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: form,
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { detail?: string }).detail ?? 'Failed to upload photos')
  }
  return res.json()
}
